import { RouteLocationNormalized } from 'vue-router';
import { EmbeddedState } from './EmbeddedState';
import { IEmbeddedState } from './IEmbeddedState';
import { FilterSelectionState } from '../filters/selection/FilterSelectionState';
import { Degree } from '../models/Degree';
import { IEmbeddedStateFactory } from './IEmbeddedStateFactory';
import { FilterSelection } from '../filters/selection/FilterSelection';
import { Routing } from '../router/Routing';
import { IRouting } from '../router/IRouting';
import { injectable } from 'inversify';
import { IStore } from '@/store/interfaces/IStore';
import { Store } from '@/store/Store';
import { PaginationDefinition } from '@/store/PaginationDefinition';
import { SortingState } from '@/sorting/SortingState';
import { SortingSelection } from '@/sorting/SortingSelection';
import { QueryParameterSelection } from './QueryParameterSelection';
import { QueryParametersState } from './QueryParametersState';

@injectable()
export class EmbeddedStateFactory implements IEmbeddedStateFactory {
	private readonly store: IStore;
	private readonly filterSelection: FilterSelection;
	private readonly queryParameterSelection: QueryParameterSelection;
	private readonly sortingSelection: SortingSelection;
	private readonly routing: IRouting;

	public constructor(
		store: Store, 
		filterSelection: FilterSelection,
		queryParameterSelection: QueryParameterSelection,
		sortingSelection: SortingSelection,
		routing: Routing
	) {
		this.store = store;
		this.filterSelection = filterSelection;
		this.queryParameterSelection = queryParameterSelection;
		this.sortingSelection = sortingSelection;
		this.routing = routing;
	}

	public fromCommitted(): IEmbeddedState {
		return new EmbeddedState()
			.withFilterSelection(this.filterSelection.state)
			.withQueryParameters(this.queryParameterSelection.state)
			.withSortingOption(this.sortingSelection.state)
			.withDegree(this.store.getters.getDegree())
			.withPage(this.store.getters.getCurrentPageNumber());
	}

	public async fromNavigationDestination(destination: RouteLocationNormalized): Promise<IEmbeddedState> {
		return await this.routing.root.retrieveEmbeddedStateFrom(destination);
	}

	public default(): IEmbeddedState {
		return new EmbeddedState()
			.withFilterSelection(new FilterSelectionState())
			.withQueryParameters(new QueryParametersState())
			.withSortingOption(new SortingState())
			.withDegree(Degree.forPortal())
			.withPage(PaginationDefinition.DEFAULT_PAGE_NUMBER);
	}
}
